import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import AssessmentBankFilters from './assessment-bank-filters'
import AssessmentBankHead from './assessment-bank-head'
import AssessmentBankBody from './assessment-bank-body'
import Fade from '@mui/material/Fade'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import FilterChip from '../components/filter-chip'

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
  },
  container: {
    flexGrow: 1,
    overflow: 'auto',
  },
  chips: {
    '&.hasChip': {
      padding: '8px 15px',
      marginTop: 0
    },
    '& .filter-chip': {
      backgroundColor: '#de3434',
      color: '#fff',
      '& .MuiChip-label': {
        padding: '0 20px'
      },
      '& .MuiChip-deleteIcon': {
      }
    }
  },
  filters: {
    display: 'flex',
    padding: '0 15px 8px 15px',
  }
})

export default function AssessmentBank({context}) {

  const classes = useStyles()
  const from = context.link()
  const hasStandardsChip = Object.values(context.quizStandardFilters).some(a => a.length > 0)
  const hasChip = !(!context.query.pattern && !context.query.id && !hasStandardsChip)

  function clearStandardFilters () {
    context.updateState({
      quizStandardFiltersCalls: {$apply: i => i + 1},
      quizStandardFilters: {expectations: {$set: []}, indicators: {$set: []}, standards:{$set: []}}
    })
  }

  return (
    <Box className={classes.root} >
      <Box className={classes.filters}>
        <AssessmentBankFilters context={context} />
      </Box>
      <Box className={clsx(classes.chips, {hasChip})}>
        {context.query.pattern && <FilterChip name="pattern" context={context} from={from} />}
        {hasStandardsChip && <FilterChip name="standards" context={context} createLabel={() => context.translate('standards-filter-chip')} from={from} onDelete={clearStandardFilters} />}
      </Box>
      <Box className={classes.content}>
        <TableContainer className={classes.container}>
          <Fade in={!context.quizSearch.assessments}>
            <Table className={classes.table}>
              <AssessmentBankHead context={context} />
              <AssessmentBankBody context={context} />
            </Table>
          </Fade>
        </TableContainer>
      </Box>
    </Box>
  )
}
